import { render, staticRenderFns } from "./lab-view.vue?vue&type=template&id=b9eb0716&"
import script from "./lab-view.vue?vue&type=script&lang=js&"
export * from "./lab-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9eb0716')) {
      api.createRecord('b9eb0716', component.options)
    } else {
      api.reload('b9eb0716', component.options)
    }
    module.hot.accept("./lab-view.vue?vue&type=template&id=b9eb0716&", function () {
      api.rerender('b9eb0716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lab-view.vue"
export default component.exports